<ph-columns *ngIf="stage === 'setup'" min="280px">
    <div>
        <strong>To set up an authenticator app:</strong>
        <ol class="setup-list">
            <li>Open your authenticator app.</li>
            <li>Tap add (+), then choose "Scan a QR code".</li>
            <li>Scan the QR code, then enter the 6-digit code it shows.</li>
        </ol>
    </div>

    <ph-stack align="center">
        <div class="qr-skeleton" *ngIf="!qrCode" aria-hidden="true"></div>
        <div class="qr" *ngIf="qrCode" [innerHTML]="qrCode"></div>

        <ph-skeleton *ngIf="!secretKey" lines="1" label="Loading setup key"></ph-skeleton>
        <ph-hint *ngIf="secretKey">Can't scan? Enter this key manually: <strong>{{ secretKey }}</strong></ph-hint>

        <ph-digit-input digits="6"
                        aria-label="Verification code"
                        [value]="code"
                        [disabled]="isSaving || isSuccess"
                        [hasError]="hasError"
                        (ph-change)="onCodeChange($event.detail)"
                        (ph-complete)="verify($event.detail)"></ph-digit-input>
    </ph-stack>
</ph-columns>

<app-recovery-codes-panel *ngIf="stage === 'codes'"
                          [codes]="recoveryCodes"
                          (acknowledgedChange)="codesAcknowledged = $event"></app-recovery-codes-panel>

<ng-template #footer>
    <ph-actions slot="footer" align="between" *ngIf="stage === 'setup'">
        <ph-button variant="secondary" mode="filled" [disabled]="isSaving || isSuccess" (click)="onBack()">{{ dismissLabel }}</ph-button>
        <ph-button [disabled]="code.length < 6 || isSaving || isSuccess" (click)="verify(code)">{{ verifyLabel }}</ph-button>
    </ph-actions>

    <ph-actions slot="footer" *ngIf="stage === 'codes'">
        <ph-button [disabled]="!codesAcknowledged" (click)="onCodesAcknowledged()">Done</ph-button>
    </ph-actions>
</ng-template>
